import { render, staticRenderFns } from "./clientinfos.vue?vue&type=template&id=1fd81f8f&scoped=true&"
import script from "./clientinfos.vue?vue&type=script&lang=js&"
export * from "./clientinfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd81f8f",
  null
  
)

export default component.exports